module.exports = __webpack_public_path__ + "media/common/images/badges/active/zrout_informaci-2dc31cf656fe0a7a2abc09424012a4f7.svg";